/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "people-to-notify",
	props:{
		vehicleId: {
			default: null
		}
	},
	data() {
		return {
			peopleToNotify: [],
			peopleToNotifyHeadings: [
				{
					text: "First Name",
					field: "firstName"
				},
				{
					text: "Last Name",
					field: "lastName"
				},
				{
					text: "Email Address",
					field: "email"
				},
				{
					text: "Phone Number",
					field: "cellNumber"
				},
				{
					text: "Role",
					field: "personToNotifyRole"
				},
				{
					text: "Is Active",
					field: "isActive"
				}
			],
			roles: [],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			customerVehicle: {},
			actionKeys:{
				edit: "edit",
				markAsActiveInactive: "markAsActiveInactive"
			},
			personToNotifyMarkAsActiveInactiveModal:{
				showModal: false,
				isSaving: false,
				modalId: "markAsActiveInactivePersonToNotifyModal",
				heading: "Mark Person To Notify As Active/Inactive",
				isActive: null,
				personToNotifyId: null
			},
			addOrUpdatePersonToNotifyModal:{
				showModal: false,
				isSaving: false,
				modalId: "addOrUpdatePersonToNotifyModal",
				heading: "Add Person To Notify",
				personToNotify: {
					personToNotifyId: null,
					firstName: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					lastName: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					emailAddress: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					phoneNumber: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					roleId: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					isActive: true
				}
			},
			filterStateChanged: false,
			filter:{
				customerSearchQuery: null,
				activeOrInactiveItems: 1,
				selectedCustomerVehicleRoleId: null,
				selectedRole: 0
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			selectedHeartbeatStatusCodeId: null
		};
	},
	methods: {
		getCustomerVehicle() {
			console.log("vehicleId", this.vehicleId);
			let request = {
				vehicleId: this.vehicleId
			};
			customerService.getCompanyVehicle(this.vehicleId).then(
				successResponse => {
					console.log("successResponse", successResponse);
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						this.customerVehicle = successResponse.data.result;
						this.setBreadcrumbs();
					}
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					alert("Unexpected error occurred");
				}
			);
		},
		getPeopleToNotify(){
			this.loading = true;
			let request = {
				vehicleId: this.vehicleId,
				personToNotifyRoleId: this.filter.selectedCustomerVehicleRoleId <= 0 ? null : this.filter.selectedCustomerVehicleRoleId,
				searchQuery: this.filter.customerSearchQuery,
				isActive: this.filter.activeOrInactiveItems
			};
			customerService.getPeopleToNotifyByCompanyVehicle(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.peopleToNotify = successResponse.data.result;
						for(let i = 0; i < this.peopleToNotify.length; i++){
							this.peopleToNotify[i].actions = [
								{
									name: "Edit",
									key: this.actionKeys.edit
								},
								{
									name: this.peopleToNotify[i].isActive ? "Mark As Inactive" : "Mark As Active",
									key: this.actionKeys.markAsActiveInactive
								}
							];
						}
						this.peopleToNotify = dataTableHelper.castFieldValues(this.peopleToNotify);
						this.filterStateChanged = false;
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					alert("Unexpected error occurred");
				}
			);
		},
		getRoles(){
			customerService.getPersonToNotifyRoles().then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.roles = successResponse.data.result;
						this.roles.unshift(
							{
								personToNotifyRoleId: 0,
								description: "All"
							});
						console.log("roles", this.roles);
						this.roles = $.map(this.roles,
							function (obj) {
								obj.id = obj.id || obj.personToNotifyRoleId;
								obj.text = obj.text || obj.description;
								return obj;
							});
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					alert("Unexpected error occurred");
				}
			);
		},
		onFilterSearchClicked(){
			console.log("Search filter clicked");
			this.getPeopleToNotify();
		},
		onActiveInactiveFilterSelected(activeOrInactiveKey){
			this.filter.activeOrInactiveItems = activeOrInactiveKey;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onRoleFilterSelect(role){
			if(this.filter.selectedRole !== role.id) {
				this.filterStateChanged = true;
			}
			this.filter.selectedRole = role.id;
			
			if(role.id === 0){
				this.filter.selectedCustomerVehicleRoleId = null;
			}
			else{
				this.filter.selectedCustomerVehicleRoleId = role.id;
			}
		},
		onAddPersonToNotifyClick(){
			this.addOrUpdatePersonToNotifyModal.showModal = true;
		},
		onCustomerVehicleActionClicked(actionAndData){
			console.log("actionAndData", actionAndData);
			switch(actionAndData.action){
				case this.actionKeys.edit:
					this.addOrUpdatePersonToNotifyModal.showModal = true;
					this.addOrUpdatePersonToNotifyModal.heading = "Edit Person To Notify - " + actionAndData.data.firstName + " " + actionAndData.data.lastName;
					this.addOrUpdatePersonToNotifyModal.personToNotify.personToNotifyId = actionAndData.data.personToNotifyId;
					this.addOrUpdatePersonToNotifyModal.personToNotify.firstName.value = actionAndData.data.firstName;
					this.addOrUpdatePersonToNotifyModal.personToNotify.lastName.value = actionAndData.data.lastName;
					this.addOrUpdatePersonToNotifyModal.personToNotify.emailAddress.value = actionAndData.data.email;
					this.addOrUpdatePersonToNotifyModal.personToNotify.phoneNumber.value = actionAndData.data.cellNumber;
					this.addOrUpdatePersonToNotifyModal.personToNotify.roleId.value = actionAndData.data.personToNotifyRoleId;
					this.addOrUpdatePersonToNotifyModal.personToNotify.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
					break;
				case this.actionKeys.markAsActiveInactive:
					this.personToNotifyMarkAsActiveInactiveModal.showModal = true;
					this.personToNotifyMarkAsActiveInactiveModal.personToNotifyId = actionAndData.data.personToNotifyId;
					this.personToNotifyMarkAsActiveInactiveModal.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
					this.personToNotifyMarkAsActiveInactiveModal.heading = "Mark Person To Notify As " + (this.personToNotifyMarkAsActiveInactiveModal.isActive ? "Inactive - " : "Active - ") + actionAndData.data.firstName + " " + actionAndData.data.lastName;
					break;
			}
		},
		onMarkPersonToNotifyActiveInactiveSelected(isActive){
			this.personToNotifyMarkAsActiveInactiveModal.isActive = isActive;
			console.log("customerMarkAsActiveInactiveModal.isActive", this.personToNotifyMarkAsActiveInactiveModal.isActive);
		},
		onMarkAsActiveInactiveSaveClick(markAsActive){
			this.personToNotifyMarkAsActiveInactiveModal.isSaving = true;
			let request = {
				personToNotifyId: this.personToNotifyMarkAsActiveInactiveModal.personToNotifyId,
				isActive: markAsActive
			};
			customerService.markPersonToNotifyAsActiveOrInactive(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.getPeopleToNotify();
						this.personToNotifyMarkAsActiveInactiveModal.showModal = false;
						this.personToNotifyMarkAsActiveInactiveModal.isActive = true;
						this.personToNotifyMarkAsActiveInactiveModal.personToNotifyId = null;
					}
					this.personToNotifyMarkAsActiveInactiveModal.isSaving = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.personToNotifyMarkAsActiveInactiveModal.isSaving = false;
					alert("Unexpected error occurred");
				}
			);
		},
		onAddOrEditPersonToNotifyModalCloseClick(){
			this.addOrUpdatePersonToNotifyModal.showModal = false;
			this.clearPersonToNotifyModel();
		},
		onRoleSelect(role){
			this.addOrUpdatePersonToNotifyModal.personToNotify.roleId.value = role.id;
		},
		onAddOrEditPersonToNotifySaveClick() {
			this.addOrUpdatePersonToNotifyModal.isSaving = true;
			let request = {
				vehicleId: this.vehicleId,
				personToNotifyId: this.addOrUpdatePersonToNotifyModal.personToNotify.personToNotifyId,
				firstName: this.addOrUpdatePersonToNotifyModal.personToNotify.firstName.value,
				lastName: this.addOrUpdatePersonToNotifyModal.personToNotify.lastName.value,
				email: this.addOrUpdatePersonToNotifyModal.personToNotify.emailAddress.value,
				phoneNumber: this.addOrUpdatePersonToNotifyModal.personToNotify.phoneNumber.value,
				roleId: this.addOrUpdatePersonToNotifyModal.personToNotify.roleId.value === null ? 0 : this.addOrUpdatePersonToNotifyModal.personToNotify.roleId.value,
				isActive: this.addOrUpdatePersonToNotifyModal.personToNotify.isActive
			};
			customerService.addOrUpdatePersonToNotifyForVehicle(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						console.log("success", successResponse);
						if(successResponse.data.customerVehiclePersonToNotifyValidationResponse.valuesAreValid) {
							this.getPeopleToNotify();
							this.clearPersonToNotifyModel();
							this.addOrUpdatePersonToNotifyModal.showModal = false;
						}
						else{
							this.addOrUpdatePersonToNotifyModal.personToNotify.firstName.hasError = successResponse.data.customerVehiclePersonToNotifyValidationResponse.firstNameValidationResponse.hasError;
							this.addOrUpdatePersonToNotifyModal.personToNotify.firstName.errorMessage = successResponse.data.customerVehiclePersonToNotifyValidationResponse.firstNameValidationResponse.message;
							
							this.addOrUpdatePersonToNotifyModal.personToNotify.lastName.hasError = successResponse.data.customerVehiclePersonToNotifyValidationResponse.lastNameValidationResponse.hasError;
							this.addOrUpdatePersonToNotifyModal.personToNotify.lastName.errorMessage = successResponse.data.customerVehiclePersonToNotifyValidationResponse.lastNameValidationResponse.message;
							
							this.addOrUpdatePersonToNotifyModal.personToNotify.emailAddress.hasError = successResponse.data.customerVehiclePersonToNotifyValidationResponse.emailValidationResponse.hasError;
							this.addOrUpdatePersonToNotifyModal.personToNotify.emailAddress.errorMessage = successResponse.data.customerVehiclePersonToNotifyValidationResponse.emailValidationResponse.message;
							
							this.addOrUpdatePersonToNotifyModal.personToNotify.phoneNumber.hasError = successResponse.data.customerVehiclePersonToNotifyValidationResponse.phoneNumberValidationResponse.hasError;
							this.addOrUpdatePersonToNotifyModal.personToNotify.phoneNumber.errorMessage = successResponse.data.customerVehiclePersonToNotifyValidationResponse.phoneNumberValidationResponse.message;
							
							this.addOrUpdatePersonToNotifyModal.personToNotify.roleId.hasError = successResponse.data.customerVehiclePersonToNotifyValidationResponse.roleValidationResponse.hasError;
							this.addOrUpdatePersonToNotifyModal.personToNotify.roleId.errorMessage = successResponse.data.customerVehiclePersonToNotifyValidationResponse.roleValidationResponse.message;

						}
					}
					this.addOrUpdatePersonToNotifyModal.isSaving = false;
				},
				errorResponse => {
					//error
					console.log("error", errorResponse);
					alert("Unexpected error occurred");
					this.addOrUpdatePersonToNotifyModal.isSaving = false;
				}
			);
		},
		clearPersonToNotifyModel(){
			this.addOrUpdatePersonToNotifyModal.personToNotify = {
				personToNotifyId: null,
				firstName: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				lastName: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				emailAddress: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				phoneNumber: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				roleId: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				isActive: true
			};
		},
		setBreadcrumbs() {
			var pageTitle = "People To Notify - " + this.customerVehicle.vehicleRegistration + " (" + this.customerVehicle.capacity + "L)";
			storeState.setPageTitleAction(pageTitle);
			breadcrumbsStoreState.updateBreadcrumbs(this.$route, pageTitle);
		}
	},
	mounted: function () {
		// this.getRoles();
	},
	watch: {
		vehicleId: {
			handler: function () {
				console.log("vehicleId", this.vehicleId);
				if (this.vehicleId !== null && this.vehicleId > 0) {
					this.getCustomerVehicle();
					this.getPeopleToNotify();
					this.getRoles();
				}
			},
			immediate: true,
			deep: true
		}
	}
};